import { STORAGE_KEYS } from '@/shared/constants/storage-keys';
import { localStorageUtil } from '@/shared/utils/local-storage';
import type { PermissionMap } from '@/shared/permissions';

/**
 * Persists the signed-in member's delegated permission set in localStorage so a
 * page refresh doesn't blank out per-user access gating (and the common Upgrade
 * popup) before the cache rehydrates.
 *
 * The value is wrapped in `{ permissions }` rather than stored bare so a stored
 * owner (`permissions: null` = full access) is distinguishable from "nothing
 * stored yet" — both of which `localStorageUtil.get` would otherwise return as
 * `null`. Primed into the query cache on login; this is the durable mirror.
 */
export interface StoredAccess {
    permissions: PermissionMap | null;
}

export function setStoredAccess(access: StoredAccess): void {
    localStorageUtil.set(STORAGE_KEYS.ACCESS, access);
}

export function readStoredAccess(): StoredAccess | null {
    return localStorageUtil.get<StoredAccess | null>(STORAGE_KEYS.ACCESS);
}

export function clearStoredAccess(): void {
    localStorageUtil.remove(STORAGE_KEYS.ACCESS);
}
